/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InsurancePaymentAccount/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function InsurancePaymentAccount({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/SourceInvoice/PaymentAccount/InsurancePaymentAccount"
  
}) {
let constantData = 'Invoice #'
let receivableHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'human_readable_id',
})
let constantData1 = ' - Payor: '
let receivableInsuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'insured.insurance_subscription.insurance_plan.insurance_company.carrier_name',
})
let constantData2 = ' (Group/Plan: '
let receivableInsuredInsuranceSubscriptionInsurancePlanNumberValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'insured.insurance_subscription.insurance_plan.number',
})
let constantData3 = ')'
let aggregateData = fromAggregate.joinNoSpace(constantData, receivableHumanReadableIdValueData, constantData1, receivableInsuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData, constantData2, receivableInsuredInsuranceSubscriptionInsurancePlanNumberValueData, constantData3)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="'Invoice #'"
 data="receivable.human_readable_id"
 aggregate="/Data/aggregate.js joinNoSpace"
 data="' - Payor: '"
 data="receivable.insured.insurance_subscription.insurance_plan.insurance_company.carrier_name"
 data="' (Group/Plan: '"
 data="receivable.insured.insurance_subscription.insurance_plan.number"
 data="')'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}